import store, { subscribe } from 'shared/store'
import { actionNames } from 'shared/store/ducks/userSession'
import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'
import { ARIA_HIDDEN, HIDDEN_CLASS } from './consts'

const SELECTOR_PRODUCT_VARIANT_EMAIL_NOTIFICATION_ICON =
  '[data-clientside-hook~="o-ProductVariantMain__email-notification-icon"]'
const SELECTOR_PRODUCT_VARIANT_DISCOUNT_BADGE =
  '[data-clientside-hook~="o-ProductVariantMain__discount_badge"]'

const SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_TEXT_ACTIVATE =
  '[data-clientside-hook~="o-BuyBoxSendEmailForm__text_activate"]'
const SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_TEXT_ACTIVATED =
  '[data-clientside-hook~="o-BuyBoxSendEmailForm__text_activated"]'

const SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_WRAPPER_USER_LOGGED_OUT =
  '[data-clientside-hook~="o-BuyBoxSendEmailForm__button__user-logged-out"]'
const SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_WRAPPER_USER_LOGGED_IN =
  '[data-clientside-hook~="o-BuyBoxSendEmailForm__button__user-logged-in"]'
const SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_USER_LOGGED_IN =
  '[data-clientside-hook~="o-BuyBoxSendEmailForm__button"]'

// if user logged in then check the value of subscribedToRevailability in session data
// subscribedToRevailability: true then show the `bell` icon instead of `discount badge`...
// ...and disable the `backInStock.button.activate` button
const emailNotification = () => {
  subscribe.after.once(actionNames.setUserSession, ({ userSession }) => {
    const buyboxSendEmailFormButtonWrapperUserLoggedOut = document.querySelector(
      SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_WRAPPER_USER_LOGGED_OUT
    )
    const buyboxSendEmailFormButtonWrapperUserLoggedIn = document.querySelector(
      SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_WRAPPER_USER_LOGGED_IN
    )
    const buyboxSendEmailFormButtonUserLoggedIn = document.querySelector(
      SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_USER_LOGGED_IN
    )
    const buyboxSendEmailFormButtonTextActivate = document.querySelector(
      SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_TEXT_ACTIVATE
    )
    const buyboxSendEmailFormButtonTextActivated = document.querySelector(
      SELECTOR_BUY_BOX_SEND_EMAIL_FORM_BUTTON_TEXT_ACTIVATED
    )

    // eslint-disable-next-line no-underscore-dangle
    const {
      pageProperties: { pzn }
    } = store.getPublicRuntimeConfig()

    if (pzn && userSession.isLoggedIn) {
      // container for out-of-stock variant link
      const productVariantOutOfStockLink = document.querySelector(
        `[data-product-variant-id~="${pzn}"]`
      )
      // bell icon
      /** @type HTMLElement */
      let productVariantEmailNotificationIcon = null
      if (productVariantOutOfStockLink) {
        productVariantEmailNotificationIcon = productVariantOutOfStockLink.querySelector(
          SELECTOR_PRODUCT_VARIANT_EMAIL_NOTIFICATION_ICON
        )
      }
      // discount badge
      /** @type HTMLElement */
      let productVariantDiscountBadge = null
      if (productVariantOutOfStockLink) {
        productVariantDiscountBadge = productVariantOutOfStockLink.querySelector(
          SELECTOR_PRODUCT_VARIANT_DISCOUNT_BADGE
        )
      }
      const { product } = userSession
      const { subscribedToRevailability } = product

      const toggleClassName = (element, force = true) => {
        if (element !== null) {
          element.classList.toggle(HIDDEN_CLASS, force)
        }
      }

      toggleClassName(buyboxSendEmailFormButtonWrapperUserLoggedOut)
      toggleClassName(buyboxSendEmailFormButtonWrapperUserLoggedIn, false)

      if (subscribedToRevailability) {
        toggleBoolStringAttr(
          productVariantEmailNotificationIcon,
          ARIA_HIDDEN,
          false
        )
        toggleClassName(buyboxSendEmailFormButtonTextActivate)
        toggleClassName(buyboxSendEmailFormButtonTextActivated, false)
        toggleBoolStringAttr(productVariantDiscountBadge, ARIA_HIDDEN, true)
        buyboxSendEmailFormButtonUserLoggedIn.disabled = true
        // prevent page reload when clicking tooltip on out-of-stock product variant
        if (productVariantOutOfStockLink) {
          productVariantOutOfStockLink.addEventListener('click', e =>
            e.preventDefault()
          )
        }
      }
    }
  })
}

export default emailNotification
